import { Hero } from "./Hero";
import { WhatIs } from "./WhatIs";
import { Marquee } from "./Marquee";
import { ExplainSection } from "./ExplainSection";
import { XSection } from "./XSection";
import { HowItWorks } from "./HowItWorks";
import { AudienceGrid } from "./AudienceGrid";
import { Founding100 } from "./Founding100";
import { FutureAI } from "./FutureAI";
import { FinalCTA } from "./FinalCTA";

export const Landing = () => (
  <main data-testid="landing-page">
    <Hero />
    <WhatIs />
    <Marquee />
    <ExplainSection />
    <XSection />
    <HowItWorks />
    <AudienceGrid />
    <Founding100 />
    <FutureAI />
    <FinalCTA />
  </main>
);
